import React, { useRef, useState } from 'react'
import { Modal } from './Modal'
import { Divide, Upload } from 'lucide-react'
import { Api } from '../Service/api'
import MatchFollowingEquation, { DifferenceAnswer } from '../Component/ManuallyGenerate/MatchFollowingEquation'
import LatexTextRendererMcq from '../helper/Mathmcq'
import McqFormation from '../Component/ManuallyGenerate/McqFormation'
import { Divider } from '@mui/material'
import { ErrorToast, SuccessToast } from './Toast'
import { getlocalStorage } from '../Service/api/configuration/localstorage'
import { useDispatch, useSelector } from 'react-redux'
import { ACTIONS } from '../redux/actions'
import { path } from '../Utils/ScreenPath'
import { useNavigate } from 'react-router-dom'

const QuestionShow = ({
    isModelOpen,
    setIsPurchaseModelOpen,
    queReportData,
    qusetionNumber,
    sectionId,
    divisionId,
    remove
}) => {
    const fileInputRef = useRef(null);
    const dispatch = useDispatch();
    const userData = getlocalStorage("userData");
    const [mistakeType, setMistakeType] = useState('Question')
    const [image, setImage] = useState(null)
    const [description, setDescription] = useState('')
    const examData = useSelector((state) => state?.SelectedDetail?.Data);

    const navigate = useNavigate();

    const handleImageRemove = (event) => {
        event.stopPropagation();
        setImage(null);
        if (fileInputRef.current) {
            fileInputRef.current.value = ""; // Reset file input to allow the same file to be uploaded again
        }
    }
    const handleImageUploadClick = () => {
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };

    const handleImageUpload = async (e) => {
        const file = e.target.files[0];
        const formData = new FormData();
        formData.append("image", file);
        const { data } = await Api.uplodedImage(formData)
        const result = JSON.parse(data);
        if (result) {
            setImage(result?.data);
        };
    }

    const handleSubmit = (event) => {
        event.preventDefault()
    }

    const handleModelClose = () => {
        setMistakeType('Question')
        setDescription('')
        setImage(null)
        setIsPurchaseModelOpen(false)
    }

    const handleModelApply = async () => {
        if (queReportData?.questionRight ||
            queReportData?.questionLeft ||
            queReportData?.subID) {
            ErrorToast('You can not replace Paragraph and Match the following Questions');
            return
        }
        dispatch(ACTIONS.startLoading())
        try {


            navigate(path.QTypeWise + `/${sectionId}/${divisionId}/true/${queReportData?.id}`);

            setTimeout(() => {
                navigate(
                    path?.Relpace +
                    `/${sectionId}/${divisionId}/${queReportData?.qtype}/${queReportData?.chapter}/true/${queReportData?.id}`
                );
            }, 0);

        } catch (e) {
            ErrorToast(e);
        } finally {
            dispatch(ACTIONS.stopLoading())
        }
    }


    const handleGotoQuestion = () => {

        navigate(path.QTypeWise + `/${sectionId}/${divisionId}`);
        setTimeout(() => {
            navigate(
                path?.QuestionSection +
                `/${sectionId}/${divisionId}/${queReportData?.qtype}/${queReportData?.chapter}`
            );

        }, 0);

    }
    let question = "queReportData"
    const answer = "queReportData"
    return (
        <div>
            <Modal
                title={`Question no ${qusetionNumber}`}  // ✅ Use curly braces, not backticks directly
                buttonText="Replace"
                width="max-w-2xl"
                disabled={false}
                modalOpen={isModelOpen}
                onGotoQuestion={handleGotoQuestion}      // ✅ Pass the function reference
                questionButtonText="Go to Question"
                onApply={handleModelApply}
                onClose={handleModelClose}
            >
                <div style={{ maxHeight: "450px", overflow: "auto" }}>
                    <div className="mb-6 text-sm font-semibold py-3">
                        <div className=" mb-2 flex gap-2 ">
                            <div>Q.</div>
                            <div>
                                {queReportData?.m_equation != 1 ?
                                    // **********************without m_equation*************************
                                    (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '-webkit-fill-available', overflow: 'auto' }}>
                                            <div style={{ fontWeight: '600' }}
                                                dangerouslySetInnerHTML={{
                                                    __html: queReportData?.finalquestion,
                                                }}
                                                className="table-container"
                                            />

                                            {(queReportData?.option1_img || queReportData?.option2_img || queReportData?.option3_img || queReportData?.option4_img || queReportData?.finaloption1 || queReportData?.finaloption2 || queReportData?.finaloption3 || queReportData?.finaloption4) && <McqFormation question={queReportData} />}

                                            {(queReportData?.qtype != "12" && queReportData?.perfact_metch?.length > 0) &&
                                                <MatchFollowingEquation data={queReportData} />
                                            }
                                        </div>
                                    ) : (
                                        <div style={{ display: 'flex', flexDirection: 'column', width: '-webkit-fill-available', overflow: 'auto' }}>
                                            {/* *****************************with m_equation********************************** */}
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: queReportData?.finalquestion,
                                                }}
                                                style={{ width: "-webkit-fill-available" }}
                                                className="table-container"
                                            />

                                            <LatexTextRendererMcq
                                                text={queReportData}
                                            />

                                            {/* match the following */}
                                            {(queReportData?.qtype != "12" && queReportData?.perfact_metch?.length > 0) &&
                                                <MatchFollowingEquation data={queReportData} />
                                            }
                                        </div>

                                    )}
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div >
    )
}

export default QuestionShow